<script lang="ts">
    import { localStorageToken } from "@/tokens";
    import { PRODUCT_HANDLE_STORAGE_KEY } from "@apps/gift_registry/constants";
    import { CommonModule } from "@modules/common_module/CommonModule";
    import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
    import { container } from "tsyringe";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import T from "@components/T.svelte";
    import Text from "@components/Typography/Text.svelte";

    export let productHandle: string | undefined = undefined;
    export let urlsBuilder: URLsBuilder;
    export let namespace: string;

    const localStorage = container.resolve(localStorageToken);
    const locationController =
        container.resolve(CommonModule).exports.locationController;

    const handleRedirect = (link: string) => {
        if (productHandle) {
            localStorage.setItem(PRODUCT_HANDLE_STORAGE_KEY, productHandle);
        }

        locationController.goTo(link);
    };
</script>

<div class="gw-gr-login-section">
    <Text>
        <T {namespace} translationKey="login_description" />
        <BaseButton
            class="gw-gr-signup-btn"
            on:click={() => handleRedirect(urlsBuilder.createRegisterUrl())}
            variant="text"
        >
            <T {namespace} translationKey="signup" />
        </BaseButton>
        <T {namespace} translationKey="or" />
        <BaseButton
            class="gw-gr-login-btn"
            on:click={() => handleRedirect(urlsBuilder.createLoginUrl())}
            variant="text"
        >
            <T {namespace} translationKey="login" />
        </BaseButton>
    </Text>
</div>

<style lang="postcss" global>
    .gw-gr-login-btn.gw-btn,
    .gw-gr-signup-btn.gw-btn {
        color: var(--gw-gr-primary-link-color);
        padding: 0;
        text-decoration: underline;
        font-weight: 600;
        font-size: var(--gw-font-size-lg);
    }
</style>
